import PixelObject from './PixelObject'

export default class Rectangle extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'RECTANGLE',
            name: 'Rectangle',
            width: 50,
            height: 50,
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.width = opts.width
        this.height = opts.height
    }

    copy(args) {
        return new Rectangle({ ...this, ...args, skipParentGeneration: true })
    }

    draw() {
        if (this.visible == '0' || this.deleted) return

        const w = this.get('width')
        const h = this.get('height')
        const r = this.get('rotate')
        const selected = this.get('selected')

        this.ctx.push()

        this.stroke()
        this.fill()

        this.position()

        this.ctx.rect(0, 0, this.getRenderPropertyValue('width'), this.getRenderPropertyValue('height'));

        this.ctx.pop()
    }
}